/* eslint-disable react-hooks/exhaustive-deps */
import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";

import Input from '../formsUi/input/Input';
import Label from '../formsUi/common/label/Label';
import ValidationMessage from '../formsUi/common/validation/ValidationMessage';
import { reformatToMask } from '../utils';

const FormInputControls = ({
    dataField,
    labelName,
    name,
    type,
    value,
    error,
    formSetting,
    overRideProps,
    isRequired,
    fieldSetting,
    onChange,
    onBlur,
    onActionChange,
    inputInfoConfig
}) => {

    const maskFormat = fieldSetting?.masked?.format;
    // Decimal number formats (e.g. "00.00") are handled entirely by Input.jsx's display-layer
    // padding - reformatToMask can never complete a value missing trailing decimal zeros (its
    // content length never matches the slot count), so it always bails out unchanged or, worse,
    // round-trips a clean number through onChange as a string, racing with any sibling masked
    // field also reformatting on the same render via FormFieldsControl's stale-snapshot merge.
    const isDecimalMaskFormat = maskFormat && !/[Xx]/.test(maskFormat) && maskFormat.includes(".");

    useEffect(() => {
        if (!maskFormat || !value || isDecimalMaskFormat) return;
        const normalized = reformatToMask(value, maskFormat);
        if (normalized !== value) {
            onChange(dataField, normalized);
        }
    }, [value, maskFormat, isDecimalMaskFormat]);

    const debouncedOnChange = useCallback(
        debounce((dataField, value) => {
            onChange(dataField, value);
        },
            fieldSetting?.debounceTime ? fieldSetting?.debounceTime : 10
        ), // Adjust the delay as needed 
        [onChange]);

    const handleInputChange = (e) => {
        if (onChange) {
            if (e.target.type !== "file") {
                if (fieldSetting?.debounceTime) {
                    debouncedOnChange(dataField, e.target.value);
                } else {
                    onChange(dataField, e.target.value);
                }
            }
        }
    };

    const handleOnBlur = () => {
        onBlur(dataField);
    };
    //  isDisable={formSetting?.isViewOnly || (overRideProps?.isDisable !== undefined ? overRideProps?.isDisable : fieldSetting?.isDisable) || false}

    const handleButtonClick = (action, data) => {
        // Your dynamic logic for button click
        onActionChange(action);
    };

    return (
        <>
            <div className={`input-label-part ${fieldSetting?.mainDivClass || ""}`}>
                {labelName && labelName !== "" && (
                    <Label labelName={labelName} htmlFor={name} isRequired={isRequired} fieldSetting={fieldSetting} />
                )}
                {fieldSetting?.subTitle ? (
                    <div className={`"section-title" `}>
                        <h5>{fieldSetting.subTitle}</h5>
                    </div>
                ) : (
                    ""
                )}
                <div className={`input-top-title ${fieldSetting?.isFormControl ? "input-with-btn" : ""} `}>
                    <Input
                        id={name}
                        name={name}
                        type={type}
                        value={value}
                        onChange={handleInputChange}
                        onBlur={handleOnBlur}
                        iconConfig={fieldSetting?.iconConfig}
                        clearIconConfig={fieldSetting?.clearIconConfig}
                        placeholder={fieldSetting?.placeholder}
                        isMasked={fieldSetting?.isMasked}
                        maskedType={fieldSetting?.maskedType}
                        isdisable={
                            formSetting?.isViewOnly ||
                            (overRideProps?.isDisable !== undefined
                                ? overRideProps?.isDisable
                                : fieldSetting?.isDisable) ||
                            false
                        }
                        isreadonly={
                            formSetting?.isReadOnly ||
                            (overRideProps?.isReadOnly !== undefined
                                ? overRideProps?.isReadOnly
                                : fieldSetting?.isReadOnly) ||
                            false
                        }
                        isAllowSpace={fieldSetting?.isallowspace}
                        {...fieldSetting}
                    />
                    {fieldSetting?.isFormControl && fieldSetting?.formControltemplate(handleButtonClick)}
                </div>
            </div>
            <ValidationMessage error={error || ""} />
        </>
    );
};

FormInputControls.propTypes = {
    dataField: PropTypes.string.isRequired,
    labelName: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.any,
    error: PropTypes.string,
    formSetting: PropTypes.object,
    formData: PropTypes.object,
    overRideProps: PropTypes.object,
    isRequired: PropTypes.bool,
    fieldSetting: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onValidation: PropTypes.func,
    onBlur: PropTypes.func,
    inputInfoConfig: PropTypes.object,
    onActionChange: PropTypes.func
};

export default React.memo(FormInputControls);
